import { addNamespace } from '../../lib';

const addNs = addNamespace('search');
export const RESET_SEARCH = addNs('RESET_SEARCH');
